import React from 'react'

import { DropdownMenu, DropdownMenuFooter } from '../DropdownMenu/DropdownMenu'

import { MessageInbox } from '../MessageInbox/MessageInbox'

import { useDispatch, useSelector } from 'react-redux'
import { setSelectedMessageId } from '../../redux/reducers/messages'

import { useTranslation } from 'react-i18next'

// Tealium
import { CATEGORIES } from '../../constants/analytics.json'
import { Button } from '../Button/Button'
import { getUserLoggedInState } from '../../redux/reducers/users'

import events, { Event } from 'pubsub/events'

export interface MessageCenterDropdownProps {
}

export const MessageCenterDropdown: React.FC<MessageCenterDropdownProps> = () => {
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation('messageCenter')
  const isLoggedIn = useSelector(getUserLoggedInState)

  const onViewMoreMessagesClick = () => {
    const clickEvent: Event = {
      authenticated: isLoggedIn,
      text: 'view all messages',
      category: CATEGORIES.MESSAGES,
      element: 'button',
      messageStatus: '',
      messageSubject: '',
      eventName: 'message_center_dropdown_click',
      messageComponent: 'dropdown',
      activity: 'Link Click',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: true,
      sendToCoreAPI: true,
      isMessageCenter: true
    }
    events.publish(clickEvent)

    dispatch(setSelectedMessageId(''))
  }
  return (
    <DropdownMenu>
      <div className='ch-c-message-center-dropdown'>
        <MessageInbox
          isInsideOfModal={false}
          showMessageCount={5}
          className='ch-c-message-inbox-dropdown'
        />
        <DropdownMenuFooter>
          <Button
            data-testid='view-more-messages-btn' className='ds-c-button ds-c-button--transparent ch-u-p--0'
            onClick={onViewMoreMessagesClick}
          >{t('View all messages')}
          </Button>
        </DropdownMenuFooter>
      </div>
    </DropdownMenu>
  )
}
